import startCase from 'lodash/startCase';

class GetValidationErrorMessageHandler {
    handle(validation, serverErrors, key, index, getFirstError = true) {
        const serverError = this._getServerError(serverErrors, key, index);

        if (serverError) {
            return serverError;
        }

        const item = this._getItem(validation, key, index);

        if (!item || !item.$error) {
            return '';
        }

        const errors = item.$errors.map(error => this.errors[error.$validator]);

        return getFirstError ? errors[0] : errors;
    }

    _getItem(validation, key, index) {
        if (isNaN(index)) {
            return validation[key];
        }

        return validation.$each[index][key];
    }

    _getServerError(serverErrors, key, index) {
        if (!isNaN(index)) {
            // @TODO
            return '';
        }

        if (serverErrors[key]?.length) {
            const error = serverErrors[key][0];

            if (key === 'base') {
                return error;
            }

            return `${startCase(key)} ${error}`;
        }

        return '';
    }

    get errors() {
        return {
            required: 'Should not be empty!',
            requiredIf: 'One of the marked elements should not be empty!',
            minLength: 'It is too short!',
            maxLength: 'It is too long!',
            numeric: 'It has to be a number!',
            email: 'Email address is not valid!',
            emails: 'One or more email addresses are invalid.',
            url: 'Url is not valid!',
            isFormatValid: 'Wrong format!',
            isYearValid: 'Wrong value!',
            hasToBePositiveNumber: 'It has to be a number above 0!',
            canNotBeNegative: 'It can not be negative number!',
            percentage: 'Should be between 0 and 100!',
            atLeastOneItem: 'Please add at least one item!',
            maxElements: 'You have chosen too many elements!',
            containDigit: 'Must contain a digit!',
            containLowercaseLetter: 'Must contain a lowercase letter!',
            containUppercaseLetter: 'Must contain an uppercase letter!',
            containSpecialChar: 'Must contain a special character!',
            containSpecialCharOrDigit: 'Must contain a special character or a digit!',
            sameAsPassword: 'Must be the same as password!',
            trustPilotAuth: 'Could not authenticate. Please review the business name and try again.',
            businessProfileNameRequired: 'Please enter a business profile name.',
            businessProfileNameTaken: 'Business profile name already in use.',
            businessProfileNameFormat: 'Name can contain only letters, numbers and spaces.',
            isValid: 'Code is not valid.',
            colorTaken: 'Picked color is already in use.',
            isAnyArrayElementInvalid: 'One of the elements is not set.',
            topicTypeRequired: 'Please select a type.',
            topicNameRequired: 'Please enter a name for this topic.',
            topicNameTaken: 'Topic name already exists.',
            wrongCredentials: 'Email or password is incorrect',
            teamNameTaken: 'Team name already exists',
            inboxNameRequired: 'Please enter an inbox name.',
            ruleNameTaken: 'Rule name already exists.',
            labelNameRequired: 'Please enter a label name.',
            ruleTypeRequired: 'Please select an action',
            statusTypeRequired: 'Please select a target',
            wrongFrontStartSymbol: 'Wildcards like <code>*</code> are not allowed at the start of a word.<br><strong>Fix:</strong> Use <code>"apple*"</code> instead of <code>"*apple"</code>.',
            noExpressionBetweenBooleanOperators: 'Each <code>OR</code> or <code>AND</code> must be between two expressions.<br><strong>Fix:</strong> <code>"error" OR "crash"</code> ✅ <code>"error" OR</code> ❌',
            requiredInvertedCommasForComplexExpressions: 'Use quotes for phrases.',
            tooManyExpressions: 'Too many expressions in a Boolean group. <br><strong>Fix:</strong> Use no more than 100 items between each AND/OR. Split into smaller groups or separate topics if needed.',
            specialCharacters: 'Special characters like +, -, and NOT are not supported. <br><strong>Fix:</strong> Remove these characters or rephrase your query without them.',
            tildeProximity: 'Tilde (~) proximity search only supports values from 1 to 5. <br><strong>Fix:</strong> Use `"load"~1` or `"load"~5` — higher values are not supported.',
            emptyQuotesOrBrackets: 'Empty quotes or brackets are not allowed.<br><strong>Fix:</strong> Avoid `""` or `()` — either remove them or add content.',
            quotesBalanced: 'Quotes must be balanced and properly closed.<br><strong>Fix:</strong> Close the quote: use `"error message"` not `"error message`.',
            bracketsBalanced: 'Brackets must be balanced and properly closed.<br><strong>Fix:</strong> Close the bracket: use `(error OR message)` not `(error OR message`.',
            missingExpressionBeforeBoolean: 'Missing expression before Boolean operator.<br><strong>Fix:</strong> Add a word before `OR`, e.g., `"error" OR "load"`.',
            missingExpressionAfterBoolean: 'Missing expression after Boolean operator.<br><strong>Fix:</strong> Add a word after `OR`, e.g., `"error" OR "load"`.',
            bracketsWithoutBooleanOperatorsInside: 'Brackets must contain at least one boolean operator.',
            uselessBrackets: 'Remove useless brackets.',
            notOperatorMustBeUsedOnlyWithAnd: '<code>NOT</code> operator must be used only with <code>AND</code>.<br><strong>Fix:</strong> Use <code>"AND NOT"</code> instead of <code>"NOT"</code>.',
        };
    }
}

export default GetValidationErrorMessageHandler;
